module.exports = __webpack_public_path__ + "static/media/18ECA9.0a82f5ea.jpg";